export default function OrgPlaceholder({ title, description }) {
  return (
    <div className="space-y-4" data-testid={`org-placeholder-${title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
      <h1 className="text-2xl font-extrabold text-slate-950 dark:text-white">{title}</h1>
      <div className="rounded-2xl border border-dashed border-slate-300 bg-slate-50 p-10 text-center dark:border-white/15 dark:bg-white/[0.03]">
        <p className="text-sm font-semibold text-slate-500 dark:text-slate-400">{description || `${title} is coming soon.`}</p>
      </div>
    </div>
  );
}
